<div
  #gridContainer
  class="image-grid"
  cdkDropList
  cdkDropListOrientation="horizontal"
  (cdkDropListDropped)="onDrop($event)"
  (mousedown)="onMouseDown($event)"
  (mousemove)="onMouseMove($event)"
  (mouseup)="onMouseUp()"
  (mouseleave)="onMouseUp()"
>
  @for (image of images(); track image.image_id; let i = $index) {
    <div class="image-grid__item" cdkDrag>
      <img [src]="image.image_url" [alt]="'Image ' + (i + 1)" />
      <button class="image-grid__remove" aria-label="Remove image" (click)="imageRemoved.emit(i)">
        <outlaw-icon name="close" [size]="14" />
      </button>
    </div>
  }
  @for (skeleton of [].constructor(uploadingCount()); track $index) {
    <div class="image-grid__skeleton"></div>
  }
</div>
